<template>
  <v-content class="tw-h-full">
    <div
      id="core-view"
      class="tw-h-full"
    >
      <v-fade-transition mode="out-in">
        <router-view />
      </v-fade-transition>
    </div>
  </v-content>
</template>

<script>
export default {
  metaInfo () {
    return {
      title: 'XPRT'
    }
  }
}
</script>


